import { createClient } from '@supabase/supabase-js';
import { getEnv } from './env';

const { supabaseUrl, supabaseAnonKey } = getEnv();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase environment variables are not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    },
    // Enable heartbeat to keep connection alive
    heartbeatIntervalMs: 30000,
    // Reconnect automatically
    reconnectAfterMs: (tries: number) => {
      // Exponential backoff: 1s, 2s, 4s, 8s, max 30s
      return Math.min(1000 * Math.pow(2, tries), 30000);
    },
    // Log connection status for debugging
    logger: (level: string, message: string, data?: any) => {
      console.log(`[Supabase Realtime] ${level.toUpperCase()}:`, message, data);
    }
  },
  // Avoid custom headers that trigger CORS preflight to Supabase Edge Functions.
  // If needed later, add via per-request headers for REST only.
  global: {
    headers: {}
  }
});

export type SupabaseClient = typeof supabase;

export function getSupabaseClient() {
  return supabase;
}
